/* ================================================================
   STORE LOCATOR – Shopify Asset JS
   assets/store-locator.js
   ================================================================ */

(function () {
  "use strict";

  // ── DEBOUNCE ───────────────────────────────────────────────────────────────
  function debounce(fn, delay) {
    var timer;
    return function () {
      clearTimeout(timer);
      var args = arguments;
      var ctx = this;
      timer = setTimeout(function () {
        fn.apply(ctx, args);
      }, delay);
    };
  }

  // ── PARSE DATA FROM LIQUID ──────────────────────────────────────────────
  let STORES = [];
  let SETTINGS = {};

  try {
    const dataEl = document.getElementById("storeDataJSON");
    if (dataEl) {
      STORES = JSON.parse(dataEl.textContent);
    }
  } catch (e) {
    console.error("Store Locator: Failed to parse store data", e);
  }

  try {
    const settingsEl = document.getElementById("storeLocatorSettings");
    if (settingsEl) {
      SETTINGS = JSON.parse(settingsEl.textContent);
    }
  } catch (e) {
    console.error("Store Locator: Failed to parse settings", e);
  }

  // ── CATEGORY COLORS ────────────────────────────────────────────────────────
  const CAT_COLOR = {
    flagship: SETTINGS.flagshipColor || "#3b82f6",
    dealer: SETTINGS.dealerColor || "#10b981",
    service: SETTINGS.serviceColor || "#f59e0b",
  };

  function catColor(cat) {
    return CAT_COLOR[cat] || "#6b7280";
  }

  function catLabel(cat) {
    return (
      { flagship: "Flagship", dealer: "Dealer", service: "Service Centre" }[
        cat
      ] || cat
    );
  }

  // ── HELPER: Escape HTML ─────────────────────────────────────────────────────
  function esc(str) {
    const div = document.createElement("div");
    div.textContent = str || "";
    return div.innerHTML;
  }

  // ── STATE ──────────────────────────────────────────────────────────────────
  let map, clusterGroup;
  const markerMap = {};
  let activeCat = "all";
  let filterText = "";

  // Selection state
  var activeStoreId = null;
  var currentPopup = null;

  // Geolocation state
  var userCoords = null;
  var userMarker = null;

  // ── DOM REFERENCES ─────────────────────────────────────────────────────────
  const $list = document.getElementById("storeList");
  const $count = document.getElementById("storeCount");
  const $filterInput = document.getElementById("slSearchInput"); // Bind to search input
  const $tabsRow = document.getElementById("tabsRow");
  const $mapContainer = document.getElementById("mapContainer");

  // Determine initial active category from tabs row if active exists
  if ($tabsRow) {
    var $firstTab = $tabsRow.querySelector(".sl-tab.active");
    if ($firstTab) {
      activeCat = $firstTab.getAttribute("data-cat") || "all";
    }
  }

  // Guard: don't run if elements are missing
  if (!$mapContainer) return;

  // ── ZOOM TO ALL VISIBLE MARKERS ────────────────────────────────────────────
  function zoomToAll() {
    if (userCoords) {
      zoomToUserAndStores();
      return;
    }
    var visibleStores = STORES.filter(function (s) {
      return markerMap[s.id] && clusterGroup.hasLayer(markerMap[s.id]);
    });
    if (visibleStores.length > 0) {
      var bounds = L.latLngBounds(
        visibleStores.map(function (s) {
          return [s.lat, s.lng];
        }),
      );
      map.fitBounds(bounds, { padding: [40, 40], maxZoom: 12, animate: true });
    }
  }

  // ── HELPER: Haversine Distance ──────────────────────────────────────────────
  function getHaversineDistance(lat1, lon1, lat2, lon2) {
    var R = 6371; // Radius of the Earth in km
    var dLat = (lat2 - lat1) * Math.PI / 180;
    var dLon = (lon2 - lon1) * Math.PI / 180;
    var a = 
      Math.sin(dLat/2) * Math.sin(dLat/2) +
      Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) * 
      Math.sin(dLon/2) * Math.sin(dLon/2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
    return R * c;
  }

  // ── ZOOM TO USER AND STORES ───────────────────────────────────────────────
  function zoomToUserAndStores() {
    if (!map || !userCoords) return;
    
    var visibleStores = STORES.filter(function (s) {
      return markerMap[s.id] && clusterGroup.hasLayer(markerMap[s.id]);
    });
    
    if (visibleStores.length > 0) {
      visibleStores.forEach(function (s) {
        if (s.lat && s.lng) {
          s.distance = getHaversineDistance(userCoords.lat, userCoords.lng, parseFloat(s.lat), parseFloat(s.lng));
        }
      });
      visibleStores.sort(function (a, b) {
        return a.distance - b.distance;
      });
      
      var points = [[userCoords.lat, userCoords.lng]];
      var countToInclude = Math.min(3, visibleStores.length);
      for (var i = 0; i < countToInclude; i++) {
        points.push([visibleStores[i].lat, visibleStores[i].lng]);
      }
      
      var bounds = L.latLngBounds(points);
      map.fitBounds(bounds, { padding: [50, 50], maxZoom: 14, animate: true });
    } else {
      map.setView([userCoords.lat, userCoords.lng], 12, { animate: true });
    }
  }

  // ── CLEAR USER LOCATION ────────────────────────────────────────────────────
  function clearUserLocation() {
    userCoords = null;
    if (userMarker && map) {
      map.removeLayer(userMarker);
      userMarker = null;
    }
  }

  // ── OPEN STORE POPUP ────────────────────────────────────────────────────────
  function openStorePopup(id, autoPan) {
    if (currentPopup) {
      map.closePopup(currentPopup);
    }

    var marker = markerMap[id];
    var store = null;
    for (var i = 0; i < STORES.length; i++) {
      if (STORES[i].id === id) {
        store = STORES[i];
        break;
      }
    }
    if (!marker || !store) return;

    currentPopup = L.popup({
      maxWidth: 240,
      autoPan: autoPan,
      offset: L.point(0, -24)
    })
    .setLatLng([store.lat, store.lng])
    .setContent(marker.popupContent);

    currentPopup.storeId = id;
    currentPopup.openOn(map);
  }

  // ── INIT MAP ───────────────────────────────────────────────────────────────
  function initMap() {
    map = L.map("mapContainer", {
      center: [
        parseFloat(SETTINGS.mapCenterLat) || 22.5,
        parseFloat(SETTINGS.mapCenterLng) || 82.5,
      ],
      zoom: parseInt(SETTINGS.mapZoom, 10) || 5,
      zoomControl: true,
      attributionControl: true,
      gestureHandling: true,
    });

    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution:
        '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
      maxZoom: 19,
    }).addTo(map);

    clusterGroup = L.markerClusterGroup({
      maxClusterRadius: parseInt(SETTINGS.clusterRadius, 10) || 60,
      spiderfyOnMaxZoom: true,
      showCoverageOnHover: false,
      zoomToBoundsOnClick: true,
    });
    map.addLayer(clusterGroup);

    // ── POPUP CLOSE ──
    // Only clear the active highlight. Do NOT zoom out here — switching between
    // nearby (clustered) markers fires a stray popupclose that would otherwise
    // reset the whole map back to the initial all-stores view.
    map.on("popupclose", function (e) {
      // Only reset active state if the closed popup belongs to the currently active store
      if (e.popup && e.popup.storeId === activeStoreId) {
        activeStoreId = null;
        document.querySelectorAll(".sl-card").forEach(function (c) {
          c.classList.remove("active");
        });
        var wrap = document.getElementById("storeLocator");
        if (wrap) wrap.classList.remove("has-active-store");
        currentPopup = null;
      }
    });

    function geocodeAddress(store, callback) {
      var query = (store.address || "") + (store.city ? ", " + store.city : "") + (store.country ? ", " + store.country : "");
      if (!query.trim()) {
        callback(null, null);
        return;
      }
      var url = "https://nominatim.openstreetmap.org/search?format=json&limit=1&q=" + encodeURIComponent(query);
      
      fetch(url)
        .then(function (res) {
          if (!res.ok) throw new Error("HTTP error " + res.status);
          return res.json();
        })
        .then(function (data) {
          if (data && data.length > 0) {
            callback(parseFloat(data[0].lat), parseFloat(data[0].lon));
          } else {
            callback(null, null);
          }
        })
        .catch(function () {
          callback(null, null);
        });
    }

    function createAndAddMarker(store) {
      var icon = L.divIcon({
        html: '<div class="sl-marker-pin"></div>',
        className: "",
        iconSize: [28, 28],
        iconAnchor: [14, 28],
        popupAnchor: [0, -28],
      });

      var marker = L.marker([store.lat, store.lng], { icon: icon });
      marker.storeId = store.id;
      
      var dirUrl =
        "https://www.google.com/maps/dir/?api=1&destination=" +
        store.lat +
        "," +
        store.lng;

      marker.popupContent =
        '<div class="sl-popup">' +
          "<strong>" +
          esc(store.name) +
          "</strong>" +
          "<p>" +
          esc(store.city) +
          ", " +
          esc(store.state) +
          " " +
          esc(store.zip) +
          "</p>" +
          "<p>" +
          esc(store.address) +
          "</p>" +
          "<p>" +
          esc(store.phone) +
          "</p>" +
          '<a href="' +
          dirUrl +
          '" target="_blank" rel="noopener">Get Directions</a>' +
          "</div>";

      marker.on("click", function () {
        selectStore(store.id);
      });
      marker.on("mouseover", function () {
        openStorePopup(store.id, false);
      });
      marker.on("mouseout", function () {
        if (activeStoreId !== store.id && currentPopup && currentPopup.storeId === store.id) {
          map.closePopup(currentPopup);
          currentPopup = null;
        }
      });

      markerMap[store.id] = marker;
      clusterGroup.addLayer(marker);
    }

    // Create markers for each store
    STORES.forEach(function (store) {
      var isInvalid =
        !store.lat ||
        !store.lng ||
        isNaN(parseFloat(store.lat)) ||
        isNaN(parseFloat(store.lng)) ||
        parseFloat(store.lat) === 0 ||
        parseFloat(store.lng) === 0;

      if (isInvalid) {
        geocodeAddress(store, function (lat, lng) {
          if (lat && lng) {
            store.lat = lat;
            store.lng = lng;
          } else {
            console.warn(
              '[Store Locator] Geocoding failed for "' +
                store.name +
                '". Applying map center fallback.',
            );
            var baseLat = parseFloat(SETTINGS.mapCenterLat) || 22.5;
            var baseLng = parseFloat(SETTINGS.mapCenterLng) || 82.5;
            store.lat = baseLat + (Math.random() - 0.5) * 0.1;
            store.lng = baseLng + (Math.random() - 0.5) * 0.1;
          }
          createAndAddMarker(store);
        });
      } else {
        createAndAddMarker(store);
      }
    });

    // Fit map to all store bounds on load
    if (STORES.length > 0) {
      var validStores = STORES.filter(function (s) {
        return s.lat && s.lng && !isNaN(s.lat) && !isNaN(s.lng);
      });
      if (validStores.length > 0) {
        var bounds = L.latLngBounds(
          validStores.map(function (s) {
            return [s.lat, s.lng];
          }),
        );
        map.fitBounds(bounds, { padding: [40, 40], maxZoom: 12 });
      }
    }

    map.on("popupopen", function (e) {
      var popup = e.popup;
      var marker = popup._source;
      if (marker && marker.storeId !== undefined) {
        var el = popup.getElement();
        if (el) {
          if (activeStoreId === marker.storeId) {
            el.classList.remove("sl-popup-hover");
          } else {
            el.classList.add("sl-popup-hover");
          }
        }
      }
    });
  }

  // ── RENDER LIST ────────────────────────────────────────────────────────────
  function renderList(stores) {
    if ($count) {
      $count.textContent =
        stores.length + " store" + (stores.length !== 1 ? "s" : "") + " found";
    }

    if (!$list) return;

    if (!stores.length) {
      if (STORES.length === 0) {
        $list.innerHTML =
          '<div class="sl-empty">' +
          "<strong>No stores added yet.</strong><br><br>" +
          'Open the Shopify Customizer and click <em>"Add block → Store"</em> to add your locations.' +
          "</div>";
      } else {
        $list.innerHTML =
          '<div class="sl-empty">No stores match your search.</div>';
      }
      return;
    }

    var html = "";
    stores.forEach(function (s) {
      var color = catColor(s.cat);
      var dirUrl =
        "https://www.google.com/maps/dir/?api=1&destination=" +
        s.lat +
        "," +
        s.lng;

      var phoneHtml = "";
      if (s.phone) {
        phoneHtml = 'Phone: <a class="sl-card-phone-link" href="tel:' + esc(s.phone) + '">' + esc(s.phone) + '</a>';
      }

      var distanceHtml = "";
      if (s.distance !== undefined) {
        distanceHtml = '<div class="sl-card-distance">' + s.distance.toFixed(1) + ' km away</div>';
      }

      html +=
        '<div class="sl-card" id="card-' +
        s.id +
        '" data-store-id="' +
        s.id +
        '">' +
        '<button class="sl-card-close" title="Close selection">✕</button>' +
        '<div class="sl-card-header">' +
        '<div class="sl-card-title-row">' +
        '<div class="sl-card-name">' + esc(s.name) + '</div>' +
        '<span class="sl-card-badge" style="color: ' + color + '; background-color: ' + color + '1a;">' + esc(s.type || catLabel(s.cat)) + '</span>' +
        '</div>' +
        distanceHtml +
        '</div>' +
        '<div class="sl-card-addr">' +
        'Address: ' + esc(s.address) + ', ' + esc(s.city) + ', ' + esc(s.state) + ' ' + esc(s.zip) +
        "</div>" +
        '<div class="sl-card-meta">' +
        '<span class="sl-card-phone">' +
        phoneHtml +
        "</span>" +
        '<a class="sl-card-dir" href="' +
        dirUrl +
        '" target="_blank" rel="noopener">Get Directions</a>' +
        "</div>" +
        "</div>";
    });

    $list.innerHTML = html;
  }

  // ── SELECT STORE ───────────────────────────────────────────────────────────
  function selectStore(id) {
    // Same card clicked again → deselect and zoom out
    if (activeStoreId === id) {
      activeStoreId = null;
      document.querySelectorAll(".sl-card").forEach(function (c) {
        c.classList.remove("active");
      });
      var wrap = document.getElementById("storeLocator");
      if (wrap) wrap.classList.remove("has-active-store");

      if (currentPopup) {
        map.closePopup(currentPopup);
        currentPopup = null;
      }
      
      if (map) {
        map.invalidateSize();
      }
      zoomToAll();
      return;
    }

    // Different store → switch to it
    activeStoreId = id;
    highlightCard(id);

    var wrap = document.getElementById("storeLocator");
    if (wrap) wrap.classList.add("has-active-store");

    var marker = markerMap[id];
    var store = null;
    for (var i = 0; i < STORES.length; i++) {
      if (STORES[i].id === id) {
        store = STORES[i];
        break;
      }
    }

    if (!store || !marker) return;

    // Use a small delay (100ms) to ensure the DOM layout reflow has finished
    // (especially on mobile devices when panel hides other cards) before invalidating size and centering.
    setTimeout(function () {
      if (!map) return;
      
      map.invalidateSize({ animate: false });

      // Make sure the popup element becomes interactive
      var popup = marker.getPopup ? marker.getPopup() : null;
      if (popup) {
        var el = popup.getElement();
        if (el) el.classList.remove("sl-popup-hover");
      }

      // Calculate target LatLng offset by 80px vertically to place the marker in the lower portion of the map.
      // This leaves ample space above the marker for the popup balloon.
      var targetLatLng = [store.lat, store.lng];
      try {
        var targetPoint = map.project([store.lat, store.lng], 14).subtract([0, 80]);
        targetLatLng = map.unproject(targetPoint, 14);
      } catch (err) {
        console.error("Offset math failed, falling back to exact center", err);
      }

      // If the marker is currently hidden inside a cluster, expand the cluster
      // FIRST, then open the popup.
      var visibleParent = clusterGroup.getVisibleParent(marker);
      if (visibleParent && visibleParent !== marker) {
        clusterGroup.zoomToShowLayer(marker, function () {
          map.setView(targetLatLng, 14, { animate: true });
          openStorePopup(id, true);
        });
      } else {
        map.setView(targetLatLng, 14, { animate: true });
        openStorePopup(id, true);
      }
    }, 100);
  }

  // ── HIGHLIGHT CARD ─────────────────────────────────────────────────────────
  function highlightCard(id) {
    document.querySelectorAll(".sl-card").forEach(function (c) {
      c.classList.remove("active");
    });
    var card = document.getElementById("card-" + id);
    if (card) {
      card.classList.add("active");
      card.scrollIntoView({ behavior: "smooth", block: "nearest" });
    }
  }

  // ── EVENT: TAB CLICKS ──────────────────────────────────────────────────────
  if ($tabsRow) {
    $tabsRow.addEventListener("click", function (e) {
      var tab = e.target.closest(".sl-tab");
      if (!tab) return;
      
      var isAlreadyActive = tab.classList.contains("active");
      
      $tabsRow.querySelectorAll(".sl-tab").forEach(function (t) {
        t.classList.remove("active");
      });
      
      if (isAlreadyActive) {
        activeCat = "all";
      } else {
        tab.classList.add("active");
        activeCat = tab.getAttribute("data-cat") || "all";
      }
      
      applyFilter();
      zoomToAll();
    });
  }

  // ── EVENT: SEARCH ──────────────────────────────────────────────────────────
  var $slSearchInput = document.getElementById("slSearchInput");
  var $slSearchBtn = document.getElementById("slSearchBtn");

  function performSearch() {
    if ($slSearchInput) {
      filterText = $slSearchInput.value;
      if (filterText.trim() !== "") {
        clearUserLocation();
      }
    }
    applyFilter();
    zoomToAll();
  }

  if ($slSearchBtn) {
    $slSearchBtn.addEventListener("click", performSearch);
  }

  if ($slSearchInput) {
    // Search dynamically as the user types or clears
    $slSearchInput.addEventListener("input", function (e) {
      filterText = e.target.value;
      if (filterText.trim() !== "") {
        clearUserLocation();
      }
      applyFilter();
      if (filterText.trim() === "") {
        zoomToAll();
      }
    });

    $slSearchInput.addEventListener("keydown", function (e) {
      if (e.key === "Enter") {
        performSearch();
      }
    });
  }

  // ── EVENT: GEOLOCATION ──────────────────────────────────────────────────────
  var $slLocationBtn = document.getElementById("slLocationBtn");
  
  if ($slLocationBtn) {
    $slLocationBtn.addEventListener("click", function (e) {
      e.preventDefault();
      
      if (!navigator.geolocation) {
        alert("Geolocation is not supported by your browser.");
        return;
      }
      
      $slLocationBtn.classList.add("loading");
      
      navigator.geolocation.getCurrentPosition(
        function (position) {
          $slLocationBtn.classList.remove("loading");
          
          userCoords = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };
          
          if ($slSearchInput) {
            $slSearchInput.value = "";
          }
          filterText = "";
          
          applyFilter();
          
          if (map) {
            var userIcon = L.divIcon({
              html: '<div class="sl-user-pulse"></div>',
              className: "",
              iconSize: [20, 20],
              iconAnchor: [10, 10]
            });
            
            if (userMarker) {
              userMarker.setLatLng([userCoords.lat, userCoords.lng]);
            } else {
              userMarker = L.marker([userCoords.lat, userCoords.lng], { icon: userIcon }).addTo(map);
            }
            
            zoomToUserAndStores();
          }
        },
        function (error) {
          $slLocationBtn.classList.remove("loading");
          var msg = "Unable to retrieve your location.";
          if (error.code === 1) {
            msg = "Location permission denied. Please allow location access in your browser settings.";
          }
          alert(msg);
        },
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0
        }
      );
    });
  }

  // ── EVENT: CARD CLICKS & HOVER (delegated) ─────────────────────────────────
  if ($list) {
    $list.addEventListener("click", function (e) {
      if (e.target.closest(".sl-card-dir") || e.target.closest(".sl-card-phone-link")) return;
      
      var closeBtn = e.target.closest(".sl-card-close");
      var card = e.target.closest(".sl-card");
      
      if (closeBtn && card) {
        e.stopPropagation();
        var storeId = parseInt(card.getAttribute("data-store-id"), 10);
        if (!isNaN(storeId)) selectStore(storeId);
        return;
      }
      
      if (card) {
        var storeId = parseInt(card.getAttribute("data-store-id"), 10);
        if (!isNaN(storeId)) selectStore(storeId);
      }
    });

    $list.addEventListener("mouseover", function (e) {
      var card = e.target.closest(".sl-card");
      if (card) {
        var storeId = parseInt(card.getAttribute("data-store-id"), 10);
        if (!isNaN(storeId) && activeStoreId !== storeId) {
          var marker = markerMap[storeId];
          if (marker) {
            marker.openPopup();
          }
        }
      }
    });

    $list.addEventListener("mouseout", function (e) {
      var card = e.target.closest(".sl-card");
      if (card) {
        var storeId = parseInt(card.getAttribute("data-store-id"), 10);
        if (!isNaN(storeId) && activeStoreId !== storeId) {
          var marker = markerMap[storeId];
          if (marker) {
            marker.closePopup();
          }
        }
      }
    });
  }

  // ── EVENT: BACK TO TOP ─────────────────────────────────────────────────────
  var $backToTop = document.getElementById("backToTop");
  if ($backToTop) {
    $backToTop.addEventListener("click", function (e) {
      e.preventDefault();
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    });
  }

  // ── APPLY FILTER ───────────────────────────────────────────────────────────
  function applyFilter() {
    var q = filterText.toLowerCase().trim();

    var filtered = STORES.filter(function (s) {
      var catOk = activeCat === "all" || s.cat === activeCat;
      var textOk =
        !q ||
        (s.name && s.name.toLowerCase().indexOf(q) > -1) ||
        (s.city && s.city.toLowerCase().indexOf(q) > -1) ||
        (s.state && s.state.toLowerCase().indexOf(q) > -1) ||
        (s.address && s.address.toLowerCase().indexOf(q) > -1) ||
        (s.zip && s.zip.indexOf(q) > -1);
      return catOk && textOk;
    });

    if (userCoords) {
      filtered.forEach(function (s) {
        if (s.lat && s.lng) {
          s.distance = getHaversineDistance(userCoords.lat, userCoords.lng, parseFloat(s.lat), parseFloat(s.lng));
        } else {
          s.distance = undefined;
        }
      });
      // Sort by distance (closest first)
      filtered.sort(function (a, b) {
        if (a.distance === undefined) return 1;
        if (b.distance === undefined) return -1;
        return a.distance - b.distance;
      });
    } else {
      STORES.forEach(function (s) {
        s.distance = undefined;
      });
    }

    var visibleIds = {};
    filtered.forEach(function (s) {
      visibleIds[s.id] = true;
    });

    // Update cluster group
    clusterGroup.clearLayers();
    STORES.forEach(function (s) {
      if (visibleIds[s.id] && markerMap[s.id]) {
        clusterGroup.addLayer(markerMap[s.id]);
      }
    });

    renderList(filtered);
  }



  // ── BOOT ───────────────────────────────────────────────────────────────────
  if (SETTINGS.dataSource === "json_asset" && SETTINGS.jsonUrl) {
    fetch(SETTINGS.jsonUrl)
      .then(function (response) {
        if (!response.ok) {
          throw new Error("Network response was not ok: " + response.statusText);
        }
        return response.json();
      })
      .then(function (data) {
        STORES = data;
        initMap();
        renderList(STORES);
      })
      .catch(function (error) {
        console.error("Store Locator: Failed to load store JSON file from Assets, falling back to blocks data", error);
        initMap();
        renderList(STORES);
      });
  } else {
    initMap();
    renderList(STORES);
  }

  setTimeout(function () {
    if (map) map.invalidateSize();
  }, 800);

  window.addEventListener("load", function () {
    if (map) map.invalidateSize();
  });
})();
